import { none, useHookstate } from "@hookstate/core";
import InputField from "../input-field/InputField"
import { accessGlobalMiscState, useGlobalMiscState } from "../../stores/misc";
import { Demerit, DisciplinaryCase } from "../../types";
import { useEffect } from "react";
import { onInputChangeNative, showSnackbar } from "../../misc/utils";
import { useUniversalFind } from "../../hooks/universal";
import DisciplinaryTableItem from "../disciplinary-table-item/DisciplinaryTableItem";
import DefaultButton from "../default-button/DefaultButton";
import Plus from "../../assets/icons/Plus";
import Cross from "../../assets/icons/Cross";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import Tick from "../../assets/icons/Tick";
import { simpleGetter } from "../../actions/common";
import { demeritsApi } from "../../api/api";
import { useDisciplinaryCases } from "../../hooks/demerit";
import DatePicker from "react-datepicker";
import { CustomDateInput } from "../CustomDateInput";
import { timeSlots } from "../../misc/constants";
import DisciplinaryTableCases from "./DisciplinaryCases";

const categoryList = [
    {
        label: 'Тип нарушения',
        additionalClassName: 'max-w-[140px]'
    },
    {
        label: 'Студент',
        additionalClassName: ''
    },
    {
        label: 'Дата создания',
        additionalClassName: ''
    },
    {
        label: 'Статус',
        additionalClassName: ''
    },
    {
        label: '',
        additionalClassName: ''
    },
];

export const EditDisciplinaryHearing = () => {
    const localState = useHookstate({});
    const state: Record<string, any> = localState.get();
    const name = state.name || "";
    const startDate = state.startDate || "";
    const startTime = state.startTime || "";
    const endTime = state.endTime || "";
    const miscState = useGlobalMiscState();
    const currentDisciplinaryHearing: any = miscState.get('currentDisciplinaryHearing') || {}
    const notInHearingList: any[] = state.notInHearingList || [];
    const inHearingList: any[] = state.inHearingList || [];
    // const notInCaseList: Demerit[] = state.notInCaseList || [];
    // const inCaseList: Demerit[] = state.inCaseList || [];
    // const demerits: Demerit[] = useUniversalFind('Demerit', {}, {
    //     include: ['main_user', 'demerit_type', 'media']
    // })
    const disciplinaryCases: any[] = useDisciplinaryCases()

    const onDateChange = (date: Date | null) => {
        localState.merge({
            startDate: date
        })
    }

    useEffect(() => {
        if (currentDisciplinaryHearing.id) {
            localState.merge({
                name: currentDisciplinaryHearing.name,
                startDate: currentDisciplinaryHearing.start_date,
                startTime: currentDisciplinaryHearing.start_time?.slice(0, 5),
                endTime: currentDisciplinaryHearing.end_time?.slice(0, 5),
                notInHearingList: disciplinaryCases.filter(disciplinaryCase => !currentDisciplinaryHearing.cases?.map((c: any) => c.id).includes(disciplinaryCase.id)),
                inHearingList: currentDisciplinaryHearing.cases?.slice().map((i: any) => ({ ...i }))
            })
        }
    }, [currentDisciplinaryHearing.id, disciplinaryCases.length, currentDisciplinaryHearing.cases?.length])

    const addToList = (from: string, to: string, item: any) => () => {
        // @ts-ignore
        localState[to]?.merge([JSON.parse(JSON.stringify(item))])
        //@ts-ignore
        const foundIndex = localState[from]?.get()?.findIndex?.(i => i.id === item.id)
        if (foundIndex >= 0) {
            // @ts-ignore
            localState[from][foundIndex].set(none)
        }
    }

    // const notInCaseButtonRender = (item: Demerit) => {
    //     return (
    //         <td className="py-2">
    //             <DefaultButton
    //                 Icon={Plus}
    //                 buttonText="Добавить в дело"
    //                 additionalStyle="py-[6px] px-3 border-valley-dark-green text-valley-dark-green"
    //                 onClick={addToList('notInCaseList', 'inCaseList', item)}
    //             />
    //         </td>
    //     )
    // }

    // const inCaseButtonRender = (item: Demerit) => {
    //     return (
    //         <td className="py-2">
    //             <DefaultButton
    //                 Icon={Cross}
    //                 buttonText="Убрать из дела"
    //                 additionalStyle="py-[6px] px-3 border-valley-red text-valley-red"
    //                 onClick={addToList('inCaseList', 'notInCaseList', item)}
    //             />
    //         </td>
    //     )
    // }

    const submit = async () => {
        const body = {
            id: currentDisciplinaryHearing.id,
            name,
            start_date: startDate,
            start_time: startTime + ":00",
            end_time: endTime + ":00",
            cases: inHearingList
        }
        const response = await simpleGetter(demeritsApi.updateDisciplinaryHearing, body)
        showSnackbar(response.success ? 'Успешно' : 'Произошла ошибка', response.success ? 'success' : 'error')
        if (response.success) {
            miscState.setBatch({
                editDisciplinaryCaseHearingModalOpen: false,
                disciplinaryHearingsTriggerFetch: (miscState.get('disciplinaryHearingsTriggerFetch') || 0) + 1
            })
        }
    }

    const validateForm = () => name.length && inHearingList.length

    const renderAddToHearingButton = (caseItem: any) => {
        return (
            <DefaultButton
                Icon={Plus}
                buttonText="Добавить"
                additionalStyle="min-w-[120px] py-[6px] px-3 border-valley-dark-green text-valley-dark-green"
                onClick={addToList('notInHearingList', 'inHearingList', caseItem)}
            />
        )
    }

    const renderDeleteFromHearingButton = (caseItem: any) => {
        return (
            <DefaultButton
                Icon={Cross}
                buttonText="Убрать"
                additionalStyle="min-w-[120px] py-[6px] px-3 border border-red-500 text-red-500 hover:bg-red-100"
                onClick={addToList('inHearingList', 'notInHearingList', caseItem)}
            />
        )
    }

    return (
        <div className="flex flex-col flex-1 items-center overflow-auto">
            <div className="w-full lg:w-3/4 flex flex-col justify-center">
                <span className="text-xl md:text-2xl text-valley-black mb-4 md:mb-6 self-center text-center">
                    Изменение заседания
                </span>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                    <InputField
                        type="text"
                        label="Название заседания"
                        value={name}
                        handleChange={onInputChangeNative(localState, 'name')}
                        additionalClassName='px-3 py-[10.5px] bg-valley-background-blue rounded-lg'
                        wrapperClassName="flex flex-col gap-2 min-w-0 col-span-2"
                    />
                    <div className="flex flex-col gap-2 min-w-0 col-span-2 md:col-span-1">
                        <p className="text-[#5F6B88] font-medium text-sm">Дата</p>
                        <DatePicker
                            selected={startDate}
                            onChange={onDateChange}
                            customInput={<CustomDateInput hasTime={false} />}
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <InputField
                        wrapperClassName="flex flex-col gap-2 min-w-0"
                        additionalClassName="px-3 py-[10.5px] bg-valley-background-blue"
                        type="select"
                        id={"start-time"}
                        label="Начало"
                        value={startTime}
                        handleChange={onInputChangeNative(localState, "startTime")}
                        options={timeSlots.map(t => ({ label: t, value: t }))}
                    />
                    <InputField
                        wrapperClassName="flex flex-col gap-2 min-w-0"
                        additionalClassName="px-3 py-[10.5px] bg-valley-background-blue"
                        type="select"
                        id={"end-time"}
                        label="Конец"
                        value={endTime}
                        handleChange={onInputChangeNative(localState, "endTime")}
                        options={timeSlots.map(t => ({ label: t, value: t }))}
                    />
                </div>
            </div>
            <div className="w-full mt-6 md:mt-8 flex-1 flex flex-col 2xl:flex-row gap-3 min-h-0">
                <div className="flex flex-col flex-1 min-h-0 p-4 md:p-6 gap-4 md:gap-6 bg-valley-background-blue rounded-xl">
                    <span className="text-valley-gray text-lg md:text-2xl font-semibold leading-tight md:leading-[26.4px]">
                        Дела не в заседании
                    </span>
                    <div className="flex flex-col flex-1 gap-3 overflow-auto">
                        {notInHearingList.map((item, index) => (
                            <DisciplinaryTableCases key={item.id ?? index} caseItem={item} hideCheckbox={true} customButtonRender={renderAddToHearingButton} />
                        ))}
                    </div>
                </div>
                <div className="flex flex-col flex-1 min-h-0 p-4 md:p-6 gap-4 md:gap-6 bg-valley-background-blue rounded-xl">
                    <span className="text-valley-gray text-lg md:text-2xl font-semibold leading-tight md:leading-[26.4px]">
                        Дела в заседании
                    </span>
                    <div className="flex flex-col flex-1 gap-3 overflow-auto">
                        {inHearingList.map((item, index) => (
                            <DisciplinaryTableCases key={item.id ?? index} caseItem={item} hideCheckbox={true} customButtonRender={renderDeleteFromHearingButton} />
                        ))}
                    </div>
                </div>
            </div>
            <div className="mt-6 md:mt-8 w-full md:w-3/5 flex flex-col sm:flex-row justify-center items-stretch sm:items-center gap-3">
                <DefaultButton
                    Icon={ArrowLeft}
                    buttonText='Вернуться'
                    additionalStyle='flex-1 bg-valley-gray text-white py-3'
                    onClick={() => miscState.set('editDisciplinaryCaseHearingModalOpen', false)}
                />
                <DefaultButton
                    Icon={Tick}
                    buttonText='Сохранить изменения'
                    additionalStyle='flex-1 bg-valley-main text-white py-3'
                    disabled={!validateForm()}
                    onClick={submit}
                />
            </div>
        </div>
    )
}